import { render, staticRenderFns } from "./advertisingdelivery.vue?vue&type=template&id=42a3cf6b&scoped=true&"
import script from "./advertisingdelivery.vue?vue&type=script&lang=js&"
export * from "./advertisingdelivery.vue?vue&type=script&lang=js&"
import style0 from "./advertisingdelivery.vue?vue&type=style&index=0&id=42a3cf6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a3cf6b",
  null
  
)

export default component.exports